
import api from '../api/app'

export const actionTypes = {
  SET_TRANSLATIONS: 'app/SET_TRANSLATIONS',
  RECEIVE_CATEGORY_TYPES: 'app/RECEIVE_CATEGORY_TYPES',
  RECEIVE_SECTORS: 'app/RECEIVE_SECTORS'
}

export const loadTranslations = (language) => {
  return (dispatch) => {
    fetch(`/i18n/${ language }.json`)
      .then(res => res.json())
      .then((translations) => {
          dispatch(setTranslations(translations,language))
      })
  }
}

export const setTranslations = (translations, language) => {
  return {
    type: actionTypes.SET_TRANSLATIONS,
    data: { translations, language }
  }
}

export const loadCategoryTypes = () => {
  return(dispatch, getStore) => {
    api.fetchCategoryTypes()
      .then((data) => dispatch(receiveCategoryTypes(data)))
  }
}

function receiveCategoryTypes(APIdata) {
  return {
    type: actionTypes.RECEIVE_CATEGORY_TYPES,
    data: APIdata
  }
}

export const loadSectors = () => {
  return(dispatch, getStore) => {
    api.fetchSectors()
      .then(data => dispatch(receiveSectors(data)))
  }
}

function receiveSectors(data) {
   return {
     type: actionTypes.RECEIVE_SECTORS,
     data
   }
}



// WEBPACK FOOTER //
// ./src/actions/app.js